import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { getSorting, getBooleanSorting } from "../components/Utils";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
  ROWS_PER_PAGE_OPTIONS,
} from "../components/Constants";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import PopupMessage from "../components/PopupMessage";
import ConfirmDialog from "../components/ConfirmDialog";
import CustomTableHead from "../components/CustomTableHead";
import ViewUserDetails from "../details/ViewUserDetails";
import AddEditUserDetails from "../details/AddEditUserDetails";
import UserReportsPage from "../containers/UserReportsPage";

import CustomPaginatorActions from "../components/CustomPaginatorActions";
import { getErrorString } from "../display/ErrorStrings";

import EditIcon from "@material-ui/icons/EditOutlined";
import AddUserIcon from "@material-ui/icons/PersonAddOutlined";
import UserReportIcon from "@material-ui/icons/PersonPinOutlined";
import UsersViewIcon from "@material-ui/icons/PeopleOutlined";
import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
import ResetIcon from "@material-ui/icons/ReplayOutlined";
import DeactivateIcon from "@material-ui/icons/ToggleOffOutlined";
import ActivateIcon from "@material-ui/icons/ToggleOnOutlined";

const columnData = [
  { id: "active", numeric: false, disablePadding: true, label: " Active" },
  { id: "name", numeric: false, disablePadding: true, label: "Login ID" },
  { id: "contact", numeric: false, disablePadding: true, label: "User Name" },
  { id: "phone", numeric: false, disablePadding: true, label: "Phone" },
  { id: "email", numeric: false, disablePadding: true, label: "Email" },
];

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  redCell: {
    color: "red",
  },
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
  spacer: {
    flex: "1 1 100%",
  },
  disabledButton: {
    backgroundColor: theme.palette.secondary.main,
    fontWeight: "bold",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

class UserManagementPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      numAccouts: 0,
      accountsPerm: {},
      accounts: [],
      selectedAccountKey: 0,
      selectedAccountObject: {},
      order: "asc",
      orderBy: "",
      page: 0,
      rowsPerPage: window.sco_small_items_per_page,
      viewAccounts: true,
      accountsAction: 0,
      accountAction: 0,
      deleteDialog: false,
      deleteInProgress: false,
      allowUserProfile: false,
      viewPopup: false,
    };
    this.handleSubpageCallback = this.handleSubpageCallback.bind(this);
    this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  resetLoginRequest() {
    fetch("on_user_reset_login", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: this.state.selectedAccountObject.name,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          if (this.state.accountAction !== 1) {
            this.setState({ accountAction: 1 });
          }
          this.setState({
            notifyString: "The user login status has been reset.",
          });
          this.setState({ viewPopup: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }
  handleAccountActions(event, action) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (action === 3) {
      this.resetLoginRequest();
    } else if (action === 4) {
      this.activationRequest();
    } else {
      this.setState({ accountAction: action });
    }
  }

  activationRequest() {
    let active = !this.state.selectedAccountObject.active;
    fetch("on_user_change_active", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: this.state.selectedAccountObject.id,
        name: this.state.selectedAccountObject.name,
        active: active,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          let items = this.state.accounts;
          items[this.state.selectedAccountKey - 1].active = active;
          this.setState({ accounts: items });
          if (this.state.accountAction !== 1) {
            this.setState({ accountAction: 1 });
          }
          this.setState({
            notifyString: active
              ? "The user  has been activated."
              : "The user  has been deactivated.",
          });
          this.setState({ viewPopup: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleAccountsActions(event, action) {
    if (action === 0) {
      this.setState({ viewAccounts: true });
    } else {
      this.setState({ viewAccounts: false });
    }
    this.setState({ accountsAction: action });
  }

  handleSubpageCallback(action, item) {
    // saved or created
    if (action === 2) {
      let accounts = this.state.accounts;
      // new user
      if (this.state.selectedAccountKey === 0) {
        accounts.unshift(item);
        let i;
        for (i = 0; i < accounts.length; i++) {
          accounts[i].index = i + 1;
        }
      }
      // updated user
      else {
        this.setState({ selectedAccountObject: item });
        accounts[this.state.selectedAccountKey - 1] = item;
      }
      this.setState({ accounts: accounts });
    }
    if (this.state.selectedAccountKey === 0) {
      this.setState({ viewAccounts: true });
      this.setState({ accountsAction: 0 });
    } else {
      this.setState({ accountAction: 1 });
    }
  }

  handleSelectAccount(event, itemKey) {
    let items = this.state.accounts;
    this.setState({ selectedAccountObject: items[this.getItemIndex(itemKey)] });
    this.setState({ selectedAccountKey: itemKey });
    this.setState({ viewAccounts: false });
    this.setState({ accountAction: 1 });
  }

  handleUnselectAccount(event) {
    this.setState({ selectedAccountKey: 0 });
    this.setState({ viewAccounts: true });
    this.setState({ accountsAction: 0 });
    this.setState({ accountAction: 0 });
  }

  handleDeleteAccount(event, action) {
    // action = 1 - confirmed
    if (action === 1) {
      this.setState({ deleteDialog: false });
      this.setState({ deleteInProgress: true });
      fetch("on_delete_user", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.state.selectedAccountObject.id,
          name: this.state.selectedAccountObject.name,
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            let items = this.state.accounts;
            items.splice(this.getItemIndex(this.state.selectedAccountKey), 1);
            let i;
            for (i = 0; i < items.length; i++) {
              items[i].index = i + 1;
            }
            this.setState({ selectedAccountKey: 0 });
            this.setState({ accounts: items });
            this.setState({ numAccounts: items.length });
            this.setState({ viewAccounts: true });
            if (reply.warning) {
              this.setState({ notifyString: reply.warningString });
            } else {
              this.setState({ notifyString: "The user has been deleted." });
            }
            this.handleUnselectAccount(null);
            this.setState({ viewPopup: true });
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
          this.setState({ viewPopup: true });
        });
      this.setState({ deleteInProgress: false });
    }
    // action = 2 - cancelled
    else if (action === 2) {
      this.setState({ deleteDialog: false });
    }
    // action = 3 - open dialog
    else if (action === 3) {
      this.setState({ deleteDialog: true });
    }
  }

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }

    this.setState({ order, orderBy });
    let data = this.state.accounts;
    if (orderBy === "active") {
      data.sort(getBooleanSorting(order, orderBy));
    } else {
      data.sort(getSorting(order, orderBy));
    }
    this.setState({ accounts: data });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
    window.sco_small_items_per_page = event.target.value;
  };

  componentDidMount() {
    fetch("on_users", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) this.setState({ errorString: reply.errorString });
          this.setState({ numAccounts: reply.numItems });
          this.setState({ accounts: reply.items });
          this.setState({ allowUserProfile: reply.allowUserProfile });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  getItemIndex(objectIndex) {
    let items = this.state.accounts;
    let i;
    for (i = 0; i < items.length; i++) {
      if (items[i].index === objectIndex) {
        return i;
      }
    }
    return objectIndex;
  }

  isSelected = (id) => this.state.selectedAccountKey === id;

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    const { order, orderBy, rowsPerPage, page } = this.state;

    let data = this.state.accounts;
    return (
      <div>
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}

        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title="Information"
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}

        {this.state.errorString.length > 0 && !this.state.viewPopup && (
          <div className={classes.toolbar}>
            <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
          </div>
        )}
        {this.state.numAccounts === 0 && this.state.errorString.length === 0 && (
          <div className={classes.toolbar}>
            <h3>{t("accountListEmpty.label")}</h3>
          </div>
        )}
        {this.state.selectedAccountKey > 0 && (
          <Paper className={classes.toolbar}>
            <Typography variant="body1" color="primary">
              &nbsp;&nbsp; {t("selectUser.label")}:&nbsp;
              <strong>{this.state.selectedAccountObject.name}</strong>
              &nbsp;&nbsp;
              <Button
                color="primary"
                onClick={(event) => this.handleUnselectAccount(event)}
              >
                <DeselectIcon />
                &nbsp;{t("deselect.button")}
              </Button>
              <Button
                color="secondary"
                style={{ position: "absolute", right: 10 }}
                onClick={(event) => this.handleDeleteAccount(event, 3)}
                disabled={this.state.deleteInProgress}
              >
                {t("delete.button")}
              </Button>
              <Divider />
            </Typography>
            <div>
              <Button
                color="primary"
                onClick={(event) => this.handleAccountActions(event, 2)}
                disabled={this.state.accountAction === 2}
              >
                <EditIcon />
                &nbsp;{t("edit.button")}
              </Button>
              &nbsp;&nbsp;
              {this.state.accountAction === 1 && (
                <Button
                  color="primary"
                  onClick={(event) => this.handleAccountActions(event, 3)}
                  disabled={this.state.accountAction === 3}
                >
                  <ResetIcon />
                  &nbsp;{t("resetLogin.button")}
                </Button>
              )}
              &nbsp;&nbsp;
              {this.state.accountAction === 1 && (
                <Button
                  color="primary"
                  onClick={(event) => this.handleAccountActions(event, 4)}
                  disabled={this.state.accountAction === 4}
                >
                  {this.state.selectedAccountObject.active && <ActivateIcon />}
                  {!this.state.selectedAccountObject.active && (
                    <DeactivateIcon />
                  )}
                  {this.state.selectedAccountObject.active
                    ? t("deactivate.label")
                    : t("activate.label")}
                </Button>
              )}
            </div>
          </Paper>
        )}

        {this.state.deleteDialog && (
          <ConfirmDialog
            title={t("confirmDelete.label")}
            text={t("deleteUser.label")}
            onCloseConfirm={this.handleDeleteAccount}
          />
        )}
        {this.state.numAccounts > 0 &&
          this.state.errorString.length === 0 &&
          (this.state.viewAccounts || this.state.accountsAction > 0) &&
          this.state.selectedAccountKey === 0 && (
            <Paper className={classes.toolbar}>
              <Toolbar>
                <Typography variant="h6" color="primary">
                  {t("users.label")}&nbsp;&nbsp;
                </Typography>
                <Button
                  variant="outlined"
                  color="primary"
                  classes={{
                    root: classes.button,
                    disabled: classes.disabledButton,
                  }}
                  onClick={(event) => this.handleAccountsActions(event, 0)}
                  disabled={this.state.accountsAction === 0}
                >
                  <UsersViewIcon />
                  &nbsp;{t("viewUsers.button")}
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  classes={{
                    root: classes.button,
                    disabled: classes.disabledButton,
                  }}
                  onClick={(event) => this.handleAccountsActions(event, 1)}
                  disabled={this.state.accountsAction === 1}
                >
                  <AddUserIcon />
                  &nbsp;{t("addUser.button")}
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  classes={{
                    root: classes.button,
                    disabled: classes.disabledButton,
                  }}
                  onClick={(event) => this.handleAccountsActions(event, 2)}
                  disabled={this.state.accountsAction === 2}
                >
                  <UserReportIcon />
                  &nbsp;{t("userReport.button")}
                </Button>
              </Toolbar>
            </Paper>
          )}

        {this.state.accountsAction === 1 && (
          <div>
            <AddEditUserDetails
              history={this.props.history}
              secureToken={this.props.secureToken}
              viewOnly={this.props.viewOnly}
              newUser={true}
              onResult={this.handleSubpageCallback}
              users={this.state.accounts}
            />
          </div>
        )}
        {this.state.accountsAction === 2 && (
          <div>
            <UserReportsPage
              history={this.props.history}
              secureToken={this.props.secureToken}
              viewOnly={this.props.viewOnly}
              users={this.state.accounts}
            />
          </div>
        )}

        {this.state.accountAction === 2 && (
          <div>
            <AddEditUserDetails
              history={this.props.history}
              secureToken={this.props.secureToken}
              viewOnly={this.props.viewOnly}
              item={this.state.selectedAccountObject}
              newUser={false}
              onResult={this.handleSubpageCallback}
            />
          </div>
        )}
        {this.state.accountAction === 1 && (
          <div>
            <ViewUserDetails
              history={this.props.history}
              secureToken={this.props.secureToken}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              item={this.state.selectedAccountObject}
            />
          </div>
        )}

        {this.state.numAccounts > 0 &&
          this.state.errorString.length === 0 &&
          this.state.viewAccounts && (
            <div className={classes.tableWrapper}>
              <TablePagination
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                page={page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                ActionsComponent={CustomPaginatorActions}
              />
              <Divider />
              <Paper elevation={5}>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <CustomTableHead
                    order={order}
                    orderBy={orderBy}
                    columnData={columnData}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {data
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((n) => {
                        const isSelected = this.isSelected(n.index);
                        return (
                          <TableRow
                            hover
                            className={classes.tableRow}
                            onClick={(event) =>
                              this.handleSelectAccount(event, n.index)
                            }
                            key={n.index}
                            selected={isSelected}
                            title={t("clickSelectUser.label")}
                          >
                            <TableCell>
                              {n.active ? t("yes.label") : t("no.label")}
                            </TableCell>
                            <TableCell>{n.name}</TableCell>
                            <TableCell>{n.contact}</TableCell>
                            <TableCell>{n.phone}</TableCell>
                            <TableCell>{n.email}</TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Paper>
            </div>
          )}
      </div>
    );
  }
}

UserManagementPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(UserManagementPage));
